import React, { useState } from "react";
import { GrEmptyCircle } from "react-icons/gr";
import { IoTriangleOutline } from "react-icons/io5";

const QuizPage = () => {
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isCorrect, setIsCorrect] = useState(false);
    const [showExplanation, setShowExplanation] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);

    const handleSubmit = () => {
        setIsSubmitted(true);
        setIsCorrect(true); // Change to `false` for testing incorrect scenarios
        setShowExplanation(true);
    };

    const styles = {
        container: {
            margin: "75px auto",
            height: "auto",
            maxWidth: "80%",
            textAlign: "center",
        },
        quizContainer: {
            padding: "20px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        },
        quizQuestion: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            marginBottom: "20px",
        },
        questionBox: {
            display: "flex",
            alignItems: "center",
            marginLeft: "20px",
        },

        questionText: {
            marginLeft: "15px",
            backgroundColor: "#f9f9f9",
            padding: "10px",
            borderRadius: "15px",
            maxWidth: "auto", // auto width
            textAlign: "left",
            height: "auto",
            border: "1px solid #ccc",
            marginBottom: "15px", // Added marginBottom to create space between question and explanation
        },
        containerExplanation: {

            position: "relative",
        },

        explanationBox: {
            display: isSubmitted ? "flex" : "none", // Show only when submitted
            flexDirection: "column",
            textAlign: "left",
            justifyContent: "center",
            width: "45%",
            height: "auto",
            backgroundColor: "#f9f9f9",
            padding: "15px",
            borderRadius: "8px",
            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
            position: "absolute", // Enable positioning
            top: "-350px",          // Move further up
            right: "20px",         // Align to the right
            zIndex: 10,
            marginRight: "-50px",        // Ensure it appears above other elements
        },

        "@media (max-width: 768px)": {
            explanationBox: {
                width: "90%",       // Expand width for narrow screens
                top: "80px",        // Lower the box to avoid overlapping
                right: "10px",      // Adjust to stay within bounds
            },
        },

        "@media (max-width: 480px)": {
            explanationBox: {
                width: "100%",      // Make it full-width for very small screens
                top: "100px",       // Further lower to ensure clarity
                right: "0px",       // Center-align the box
                left: "0px",        // Center-align the box
                margin: "auto",     // Center it horizontally
            },
        },

        buttons: {
            display: "flex",
            flexDirection: "column",
            gap: "8px", // Slightly smaller gap between buttons
            justifyContent: "center", // Centers the buttons vertically
            alignItems: "stretch", // Centers the buttons horizontally
            height: "auto", // Ensures the container fills the full screen height
            marginBottom: "20px",
            marginTop: "20px",
            marginRight: "40px",

        },
        button: {
            padding: "10px 20px",
            backgroundColor: "white", // Green background
            color: "black",
            border: "none",
            borderRadius: "15px",
            cursor: "pointer",
            fontSize: "16px",
            width: "100%",
            border: "1px solid #ccc",
        },
        buttonContainer: {
            display: "flex",            // Enables flexbox
            justifyContent: "center",   // Centers the button horizontally
            alignItems: "center",       // Centers the button vertically if the container has height
            width: "100%",
            gap: "50px",                // Ensures the container takes up the full width
        },

        buttonStarting: {
            padding: "10px 20px",
            backgroundColor: "white", // Button background color
            color: "black",
            border: "none",
            borderRadius: "15px",
            cursor: "pointer",
            fontSize: "16px",
            width: "40%",              // 40% width of the container
            border: "1px solid #ccc",
        },

        optionsContainer: {
            backgroundColor: "#f8d7da",
            padding: "15px",
            borderRadius: "8px",
            marginTop: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            width: isSubmitted ? "50%" : "85%",
            maxWidth: "90%", // Ensures it doesn't exceed the screen width
            margin: isSubmitted ? "20px 0 20px auto" : "20px auto", // Center or right-align
            textAlign: "center",
            transform: isSubmitted ? "translateX(-100%)" : "none", // Shift by a percentage to avoid going off-screen
            transition: "transform 0.3s ease, width 0.3s ease", // Smooth transition for both transform and width
        },

        optionButton: {
            padding: "10px",
            margin: "5px 0",
            border: "1px solid #ddd",
            borderRadius: "5px",
            backgroundColor: "#fff",
            cursor: "pointer",
            width: "100%",
            fontSize: "16px",
            textAlign: "left",
            backgroundColor: selectedOption
                ? isCorrect
                    ? "#d4edda"
                    : "#f8d7da"
                : "#fff", // Highlight based on selected option
            color: "#000",
        },
    };

    return (
        <div style={styles.container}>
            <div style={styles.quizContainer}>
                <div style={styles.quizQuestion}>
                    <div style={styles.questionBox}>
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/images/question15.png`}
                            alt="icon"
                            style={{ width: "80px", marginBottom: "0" }} // Image size reduced
                        />
                        <div style={styles.questionText}>
                            <h5>What is the meaning of "ありがとう"?</h5>
                        </div>
                    </div>
                    {/* {showExplanation && (
                        <div style={styles.explanationBox}>
                            <h5>Explanation</h5>
                            <p>"ありがとう" means "Thank you" in Japanese.

                            </p>
                        </div>
                    )} */}
                </div>
                <div style={styles.optionsContainer}>
                    <button
                        style={styles.optionButton}
                        onClick={() => setSelectedOption(1)}
                        disabled={isSubmitted}
                    >
                        Option 1: Thank you
                    </button>
                    <button
                        style={styles.optionButton}
                        onClick={() => setSelectedOption(2)}
                        disabled={isSubmitted}
                    >
                        Option 2: Goodbye
                    </button>
                    <button
                        style={styles.optionButton}
                        onClick={() => setSelectedOption(3)}
                        disabled={isSubmitted}
                    >
                        Option 3: Please
                    </button>
                </div>

                <div style={styles.buttons}>

                    {!isSubmitted ? (
                        <>
                            <div style={styles.buttonContainer}>
                                <button style={styles.buttonStarting} onClick={handleSubmit}>
                                    Submit
                                </button>
                                <button style={styles.buttonStarting} >
                                    Skip
                                </button>
                            </div>
                        </>
                    ) : (

                        <>
                            <div style={styles.containerExplanation}>
                                <div style={styles.explanationBox}>
                                    <h5>Explanation</h5>
                                    <p>"ありがとう" means "Thank you" in Japanese.

                                    </p>
                                </div>

                                <div style={styles.buttons}>
                                    {showExplanation ? (
                                        <>
                                            <button style={styles.button}>Don’t Want to Reattempt</button>
                                            <button style={styles.button}>Want to Reattempt</button>
                                            <button style={styles.button}>Move to Next</button>
                                            <button style={styles.button}>Back to Home</button>
                                        </>
                                    ) : (
                                        <button style={styles.button}>Back to Home</button>
                                    )}
                                </div>
                            </div>

                        </>
                    )}
                </div>

            </div>
        </div>
    );
};

export default QuizPage;
